import axios from "axios";
import { ApiUrl, header } from "../../utils/modules";

class PresenceServices {
  getAll(params = {}) {
    return axios.get(ApiUrl + "presence", { ...header(), params });
  }

  getOne(id) {
    return axios.get(ApiUrl + `presence/${id}`, header());
  }

  create(data) {
    return axios.post(ApiUrl + "presence", data, header());
  }

  update(id, data) {
    return axios.put(ApiUrl + `presence/${id}`, data, header());
  }

  delete(id) {
    return axios.delete(ApiUrl + `presence/${id}`, header());
  }

  insertOrUpdate(data) {
    return axios.post(ApiUrl + "presence/insertOrUpdate", data, header());
  }
}


export default new PresenceServices();
